import { getSegmentIds } from "./getSegmentIds";

export const isHighReturner = async (appConfig) => {
  const segments = await getSegmentIds();

  if (!segments || !appConfig || !appConfig.highReturnersSegmentIds) {
    return false;
  }

  const highReturnerIds = appConfig.highReturnersSegmentIds.split(",");

  return segments.some(({ segmentId }) => highReturnerIds.includes(segmentId));
};
